// @ts-nocheck
import React from 'react';

const VypusknykyPage = () => {
  return (
    <section className="pt-2 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse text-white md:flex-row-reverse">
          <div className="relative md:w-3/5 bg-[#A81414] md:h-[400px] px-6 py-2 md:p-8 md:rounded-tr-xl max-md:rounded-bl-xl md:rounded-bl-none rounded-br-xl ">
            <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-auto">Випускники</h2>
            <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
              Це рух, історична пам’ять якого сягає 24 червня 1870 року, дня, коли група «перших студентів» з’явилася в ораторії Турину, щоб відвідати та привітати отця Боско з нагоди його іменин, які відзначалися в цю дату. Перша «братерська агапе» відбулася 19 липня 1874 р. і започаткувала звичай щорічної зустрічі, яка й сьогодні відбувається в салезіянських домах.
            </div>
            <div className="pt-3 pb-3 md:pl-8 hyphens-auto max-md:leading-5">
              У 1884 році перша група з 300 студентів взяла на себе зобов’язання підтримувати отримане виховання, продовжувати працювати на користь нужденної молоді, плекати дружбу та солідарність серед членів. Перший статут було складено в Турині 8 грудня 1911 року з нагоди першого Міжнародного конгресу проведеного отцем Филипом Рінальді.
            </div>
          </div>
          <div className="relative md:w-2/5">
            <div class="hidden md:block absolute md:top-1/2 md:right-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[200px] md:border-b-[200px] md:border-r-[100px]
              border-t-transparent border-b-transparent border-l-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <img
              className="md:h-[400px] object-cover object-left rounded-tr-xl md:rounded-bl-xl rounded-tl-xl md:rounded-tr-none"
              src="/images/vypusknykypage.JPG"
              alt=""
            />
          </div>
        </div>
        <div className="py-6 md:px-16">
            <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
              <li>
              Випускники отця Боско – це люди, які брали участь в ораторії, школі чи інших салезіянських діяльностях та отримали підготовку до життя на основі принципів превентивної системи отця Боско: розуму, релігії та діючої любові.
              </li>
            </ul>
          </div>
      </div>
    </section>
  );
};

export default VypusknykyPage;
